<template>
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel">Acceso al Portal de Autoservicio</h4>
                </div>

                <form class="form-horizontal" role="form" @submit.prevent="login()">

                    <!-- modal para la carga -->
                    <loading :active.sync="isLoading" color="#9D2449" background-color="#CCCCCC" />

                    <div class="modal-body">
                        <center>
                        <label id="modalLabelError" v-show="mensajeErrorModal"
                                style="color: black; font-size: 14px; margin-bottom: 12px;">
                                {{descripcionMensajeError}}
                        </label>
                        </center>
                        <div class="form-group">
                            <label class="col-sm-4 control-label" for="email-03">*Usuario:</label>
                            <div class="col-sm-8">
                                <input class="form-control" id="email-03"
                                        type="text" v-model="username" required
                                        oninvalid="this.setCustomValidity('El usuario es requerido')"
                                        @keyup="validaKeyUpModal"> 
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-4 control-label" for="password-03">*Contraseña:</label>
                            <div class="col-sm-8">
                                <input class="form-control" id="password-03"
                                        type="password" v-model="password" required 
                                        oninvalid="this.setCustomValidity('La contraseña es requerida')"
                                        @keyup="validaKeyUpModal">
                            </div>
                        </div>
                        <div class="col-sm-offset-4 col-sm-8">
                            <legend class="form-legend">
                                *Campos obligatorios
                            </legend>
                        </div>
<!--                        
                        <div class="col-sm-offset-1 col-sm-11">
                            <legend class="form-legend">
                                *En caso de error al ingresar con sus datos, favor de reportar a los correos israel.gomez@sct.gob.mx y olivia.lopez@sct.gob.mx
                            </legend>
                        </div>
-->                    
                    </div>
                    <div class="modal-footer" style="margin-top: 0">
                        <div class="form-group">
                            <button type="button" class="btn btn-default" @click="limpiarModalLogin()">Cancelar</button>
                            <button type="submit" class="btn btn-primary" style="margin-left: 35px;">
                                Iniciar sesión
                            </button>
                            <button type="button" id="cerrarModalBoton" data-dismiss="modal" style="display:none"></button> 
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import Vue from 'vue';
import loading from 'vue-loading-overlay'

export default {
    name:'SctModalLogin',
    components: {
        loading
    },
    data() {
        return {
            errorKeys: [44,45,46,176,177,178,179],
            username: '',
            password: '',
            mensajeErrorModal: false,
            descripcionMensajeError: '',
            isLoading: false
        }
    },
    methods: {
        limpiarModalLogin() {
            this.username = '';
            this.password = '';
            this.mensajeErrorModal = false;
            this.descripcionMensajeError = '';
            document.getElementById("cerrarModalBoton").click();
        },
        validaKeyUpModal: function(event) {
            if (this.errorKeys.includes(event.keyCode)) {
                document.getElementById(event.target.id).
                setCustomValidity(event.target.id === 'email-03' ? 'El usuario es requerido' : 'La contraseña es requerida');
            } else {
                document.getElementById(event.target.id).setCustomValidity('');
            }
        },
        login() { 
            this.isLoading = true
            axios.post(Vue.prototype.$globalHost + '/login', {
                "usuario": this.username,
                "password": this.password
            })
            .then(response => {
                //console.log(response);
                let token = response.headers.authorization;
                localStorage.setItem('token', token)
                localStorage.setItem('role', response.data.cRol)
                localStorage.setItem('name', response.data.cUsuario)
                localStorage.setItem('user_rfc', (response.data.cRfc != undefined?response.data.cRfc:''))
                localStorage.setItem('user_id', response.data.cIdUsuario)
                //console.log(localStorage.getItem('user_id') + "::" + localStorage.getItem('role'))
               
                this.limpiarModalLogin();
                this.$emit("custom-login", localStorage.getItem('user_id'),  localStorage.getItem('user_rfc'));
            })
            .catch(error => { 

                console.log(error)
                this.mensajeErrorModal = true;
                if (error == 'Error: Network Error') {
                    this.descripcionMensajeError = 
                    'La conexión ha fallando, revise su conexión a internet y vuelva a intentarlo'
                } else if (error.response.status === 401 || error.response.status === 403) {
                    this.descripcionMensajeError = 
                    'Su usuario o contraseña son incorrectos, favor de intentar nuevamente.' + 
                    ' En caso contrario reporte su incidente al correo:' + 
                    '  mesadeayuda@sedatu.gob.mx'
                    //'Tus datos de acceso son incorrectos, favor de intentarlo ' +
                    //'nuevamente.'    // o contactar al administrador de Directorio Activo.'
                } else {
                    this.descripcionMensajeError = 
                    'Ocurrió un error al ingresar, por favor intenta de nuevo'
                }
            })
            .finally(() => this.isLoading = false)
        }
    }
}
</script>